module.exports = __webpack_public_path__ + "static/img/naniungo-slide-9.60bfbb0f.jpg";